module.exports = __webpack_public_path__ + "img/service_AgeTech산업.0e395ce8.png";